var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-3 py-2",class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.content},[_c('BaseAvatar',{attrs:{"url":_vm.avatar,"size":45}}),_c('span',{class:_vm.$style.nameText},[_vm._v(_vm._s(_vm.name))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }